export interface CondicionConfig {
  codigo: string;
  label: string;
  color: string;
  oculto: boolean;
  sistema: boolean;
}

export const CONDICIONES_POR_CARA: CondicionConfig[] = [
  { codigo: "caries",                 label: "Caries",                 color: "#d32f2f", oculto: false, sistema: true },
  { codigo: "restauracion_composite", label: "Restauración composite", color: "#1976d2", oculto: false, sistema: true },
  { codigo: "restauracion_amalgama",  label: "Restauración amalgama",  color: "#455a64", oculto: false, sistema: true },
  { codigo: "restauracion_metalica",  label: "Restauración metálica",  color: "#f9a825", oculto: false, sistema: true },
  { codigo: "sellante",               label: "Sellante",               color: "#388e3c", oculto: false, sistema: true },
  { codigo: "fractura",               label: "Fractura",               color: "#7b1fa2", oculto: false, sistema: true },
];

export const CONDICIONES_POR_DIENTE: CondicionConfig[] = [
  { codigo: "ausente",             label: "Ausente",             color: "#9e9e9e", oculto: false, sistema: true },
  { codigo: "extraccion_indicada", label: "Extracción indicada", color: "#c62828", oculto: false, sistema: true },
  { codigo: "corona",              label: "Corona",              color: "#0288d1", oculto: false, sistema: true },
  { codigo: "endodoncia",          label: "Endodoncia",          color: "#6a1b9a", oculto: false, sistema: true },
  { codigo: "implante",            label: "Implante",            color: "#00695c", oculto: false, sistema: true },
  { codigo: "pontico",             label: "Póntico",             color: "#5d4037", oculto: false, sistema: true },
  { codigo: "no_erupcionado",      label: "No erupcionado",      color: "#bdbdbd", oculto: false, sistema: true },
];

export const POR_DIENTE_QUE_LIMPIAN_CARAS = ["ausente", "extraccion_indicada", "no_erupcionado"];

export const SEVERIDAD_CARA: string[] = [
  "caries",
  "fractura",
  "restauracion_metalica",
  "restauracion_amalgama",
  "restauracion_composite",
  "sellante",
];

export const CARAS = ["oclusal", "vestibular", "lingual", "mesial", "distal"] as const;
export type Cara = typeof CARAS[number];

export const FDI_VALIDOS: string[] = [
  "11", "12", "13", "14", "15", "16", "17", "18",
  "21", "22", "23", "24", "25", "26", "27", "28",
  "31", "32", "33", "34", "35", "36", "37", "38",
  "41", "42", "43", "44", "45", "46", "47", "48",
  "51", "52", "53", "54", "55",
  "61", "62", "63", "64", "65",
  "71", "72", "73", "74", "75",
  "81", "82", "83", "84", "85",
];

export const NOMBRES_FDI: Record<string, string> = {
  "11": "Incisivo central superior derecho",
  "12": "Incisivo lateral superior derecho",
  "13": "Canino superior derecho",
  "14": "Primer premolar superior derecho",
  "15": "Segundo premolar superior derecho",
  "16": "Primer molar superior derecho",
  "17": "Segundo molar superior derecho",
  "18": "Tercer molar superior derecho",
  "21": "Incisivo central superior izquierdo",
  "22": "Incisivo lateral superior izquierdo",
  "23": "Canino superior izquierdo",
  "24": "Primer premolar superior izquierdo",
  "25": "Segundo premolar superior izquierdo",
  "26": "Primer molar superior izquierdo",
  "27": "Segundo molar superior izquierdo",
  "28": "Tercer molar superior izquierdo",
  "31": "Incisivo central inferior izquierdo",
  "32": "Incisivo lateral inferior izquierdo",
  "33": "Canino inferior izquierdo",
  "34": "Primer premolar inferior izquierdo",
  "35": "Segundo premolar inferior izquierdo",
  "36": "Primer molar inferior izquierdo",
  "37": "Segundo molar inferior izquierdo",
  "38": "Tercer molar inferior izquierdo",
  "41": "Incisivo central inferior derecho",
  "42": "Incisivo lateral inferior derecho",
  "43": "Canino inferior derecho",
  "44": "Primer premolar inferior derecho",
  "45": "Segundo premolar inferior derecho",
  "46": "Primer molar inferior derecho",
  "47": "Segundo molar inferior derecho",
  "48": "Tercer molar inferior derecho",
  "51": "Incisivo central temporal superior derecho",
  "52": "Incisivo lateral temporal superior derecho",
  "53": "Canino temporal superior derecho",
  "54": "Primer molar temporal superior derecho",
  "55": "Segundo molar temporal superior derecho",
  "61": "Incisivo central temporal superior izquierdo",
  "62": "Incisivo lateral temporal superior izquierdo",
  "63": "Canino temporal superior izquierdo",
  "64": "Primer molar temporal superior izquierdo",
  "65": "Segundo molar temporal superior izquierdo",
  "71": "Incisivo central temporal inferior izquierdo",
  "72": "Incisivo lateral temporal inferior izquierdo",
  "73": "Canino temporal inferior izquierdo",
  "74": "Primer molar temporal inferior izquierdo",
  "75": "Segundo molar temporal inferior izquierdo",
  "81": "Incisivo central temporal inferior derecho",
  "82": "Incisivo lateral temporal inferior derecho",
  "83": "Canino temporal inferior derecho",
  "84": "Primer molar temporal inferior derecho",
  "85": "Segundo molar temporal inferior derecho",
};
